import { useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import CarFilter from "./carFilter"; // Adjust the path as necessary
import { FaHeart, FaRegHeart } from "react-icons/fa"; // Import Heart icons
import { getUser } from "../Utility/getUser"; // Import the getUser function

const Cars = () => {
  const [cars, setCars] = useState([]);
  const [filters, setFilters] = useState({
    name: '',
    maxPrice: 10000,
    minPrice: 50,
  });
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await fetch("https://panel.masit.net/api/view.php?table=items"); // Replace with your API endpoint
        const data = await response.json();
        setCars(data);
      } catch (error) {
        console.error("Error fetching car data:", error);
      }
    };

    const fetchFavorites = async () => {
      const user = getUser();
      if (user) {
        try {
          const response = await fetch(`https://panel.masit.net/api/view.php?table=myfavorite&favorite_usersid=${user.users_id}`);
          const data = await response.json();
          if (Array.isArray(data)) {
            setFavorites(data.map(fav => fav.favorite_itemsid));
          }
        } catch (error) {
          console.error("Error fetching favorite data:", error);
        }
      }
    };

    fetchCars();
    fetchFavorites();
  }, []);

  const handleFavoriteClick = async (carId) => {
    const user = getUser();
    if (!user) {
                  // Display a Tailwind CSS alert box
                  const alertBox = document.createElement('div');
                  alertBox.className = 'fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-red-500 text-white p-4 rounded shadow-lg';
                  alertBox.textContent = 'Login or Signup First!';
                  document.body.appendChild(alertBox);
                
                  setTimeout(() => {
                    alertBox.remove();
                  }, 3000);
                  
          
          return;
    }

    if (favorites.includes(carId)) {
      // Remove from favorites
      try {
        const response = await fetch('https://panel.masit.net/api/product/deleteFromTable.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            table: 'favorite',
            where: 'favorite_itemsid = ? and favorite_usersid = ?',
            values: [carId, user.users_id],
          }),
        });

        const data = await response.json();
        if (data.status?.includes("success")) {
          setFavorites(favorites.filter(fav => fav !== carId));
        } else {
          console.error('Failed to remove from favorites:', data.message);
        }
      } catch (error) {
        console.error('Error removing from favorites:', error);
      }
    } else {
      // Add to favorites
      try {
        const response = await fetch('https://panel.masit.net/api/product/create.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            table: 'myfavorite',
            data: {
              favorite_usersid: user.users_id, // Use the user ID from the getUser function
              favorite_itemsid: carId,
            },
          }),
        });

        const data = await response.json();
        if (data.message?.includes("erfolgreich")) {
          setFavorites([...favorites, carId]);
        } else {
          console.error('Failed to add to favorites:', data.message);
        }
      } catch (error) {
        console.error('Error adding to favorites:', error);
      }
    }
  };

  const filteredCars = cars.filter((car) => {
    return (
      (filters.name === '' || car.items_name.toLowerCase().includes(filters.name.toLowerCase())) &&
      (filters.maxPrice === '' || car.items_price <= parseFloat(filters.maxPrice)) &&
      (filters.minPrice === '' || car.items_price >= parseFloat(filters.minPrice))
    );
  });

  return (
    <div className="pb-24">
      <div className="container">
        {/* Heading */}
        <h1
          data-aos="fade-up"
          className="text-3xl sm:text-4xl font-semibold font-serif mb-3 text-gray-900 dark:text-white"
        >
          Lorem ipsum dolor
        </h1>
        <p data-aos="fade-up" data-aos-delay="400" className="text-sm pb-10 text-gray-700 dark:text-gray-300">
          Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolor iure
          nemo ab?
        </p>
        {/* Car Filter */}
        <CarFilter filters={filters} setFilters={setFilters} />
        {/* Car listing */}
        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-16">
            {filteredCars.map((car, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={car.aosDelay}
                className="space-y-3 border-2 border-gray-300 hover:border-red-600 dark:border-gray-700 dark:hover:border-red-600 p-3 rounded-xl relative group"
              >
                <a href={`/ProductDetail/${car.items_id}`} className="block w-full h-[120px] relative">
                  <img
                    src={car.items_image}
                    alt={car.items_name}
                    className="w-full h-[120px] object-contain sm:translate-x-8 group-hover:sm:translate-x-16 duration-700"
                  />
                </a>
                <div className="space-y-2">
                  <h1 className="text-red-500 font-semibold">{car.items_name}</h1>
                  <div className="flex justify-between items-center text-xl font-semibold">
                    <p>€{car.items_price}/Day</p>
                    <a href={`/ProductDetail/${car.items_id}`}>{car.items_desc}</a>
                  </div>
                </div>
                <p className="text-l font-semibold absolute top-0 left-3">
                  {car.aosDelay} KM
                </p>
                <button
                  onClick={() => handleFavoriteClick(car.items_id)}
                  className="absolute top-3 right-3 text-red-500"
                >
                  {favorites.includes(car.items_id) ? <FaHeart /> : <FaRegHeart />}
                </button>
              </div>
            ))}
          </div>
        </div>
        {/* End of car listing */}
        <div className="grid place-items-center mt-8">
          <button data-aos="fade-up" className="button-outline hover:bg-red-600 text-black hover:text-white dark:text-white border-red-500">
            Get Started
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Cars;
